<div class="spacing--padding-all spacing--margin-all">
  <h6 class="text--h6">{{ 'settings.energy.description' | translate }}</h6>
  <div class="radio-group-wrapper">
    <mat-radio-group
      class="radio-group"
      [(ngModel)]="selectedEnergySystem"
      (ngModelChange)="changeSystem($event, 'energy')"
    >
      <mat-radio-button
        *ngFor="let energyUom of energySystem"
        [value]="energyUom"
        [attr.data-test]="'settings__energy-' + energyUom"
      >
        {{ 'settings.energy.' + energyUom | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="wrapper--spacing-vertical">
    <h6 class="text--h6">{{ 'settings.lysine.description' | translate }}</h6>
    <div class="radio-group-wrapper">
      <mat-radio-group
        class="radio-group"
        [(ngModel)]="selectedLysineSystem"
        (ngModelChange)="changeSystem($event, 'lysine')"
      >
        <mat-radio-button
          *ngFor="let lysineUom of lysineSystem"
          [value]="lysineUom"
          [attr.data-test]="'settings__lysine-' + lysineUom"
        >
          {{ 'settings.lysine.' + lysineUom | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
